/**
 * The moment a chapter link asks the video of the page to start at (utils/videoChapters.ts). The links
 * are in the post text (PostContent), the player in the page header (HeaderSource): this shared state
 * carries the request from one to the other. `at` makes two clicks on the same chapter two requests.
 */
export const useVideoSeek = () =>
  useState<{ seconds: number; at: number } | null>('video-seek', () => null)
